import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

export default function HomeIntro() {
  return (
    <section className="border-b border-background-200 bg-background-50 py-10 md:py-14">
      <div className="mx-auto max-w-[1360px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:items-end lg:gap-12">
          <div className="lg:col-span-7">
            <p className="mb-3 flex items-center gap-2 font-label text-xs font-medium uppercase tracking-[0.22em] text-primary-600">
              <span className="block h-px w-7 bg-primary-500" aria-hidden="true" />
              {siteInfo.tagline}
            </p>
            <h1 className="mb-4 font-heading text-2xl font-bold leading-tight text-foreground-950 md:text-4xl lg:text-5xl">
              {siteInfo.name}
              <span className="mt-2 block font-heading text-lg font-bold text-foreground-700 md:text-2xl">
                持续追踪每一条线索，跟进回应、反转与最新进展
              </span>
            </h1>
            <p className="mb-6 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              我们不做一次性爆料的搬运工。任何一条线索进入黑瓜爆料，都会拥有一条自己的时间线，从首次流出开始，
              到当事人回应、证据反转、事件收束，逐步追加，方便你一次看清整件事的来龙去脉。
            </p>
            <div className="flex flex-col gap-3 sm:flex-row">
              <Link
                to="/news"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-radar-line text-base" />
                进入追踪流
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 px-6 py-3 font-label text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
              >
                了解追踪方法
                <i className="ri-arrow-right-line text-base" />
              </Link>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-300 bg-background-300">
              {siteInfo.stats.map((stat) => (
                <div key={stat.label} className="bg-background-50 p-4 md:p-5">
                  <p className="mb-1 font-heading text-2xl font-bold tabular-nums text-primary-600 md:text-3xl">
                    {stat.value}
                    <span className="ml-1 font-label text-xs font-normal text-foreground-500 md:text-sm">
                      {stat.suffix}
                    </span>
                  </p>
                  <p className="font-label text-xs text-foreground-600 md:text-sm">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>
            <p className="mt-3 font-label text-xs text-foreground-500">
              数据统计自 {siteInfo.since} 年至今的全部公开追踪记录
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}